function isNull(object){    
  if(object == null || typeof object == "undefined"){    
    return true;    
  }    
  return false;    
};   
function getWeek(dateString){  
  let date = null  
  if(isNull(dateString)){  
    date = new Date();  
  }else{  
    var dateArray = dateString.split("-");  
    date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);  
  } 
  return "星期" + "日一二三四五六".charAt(date.getDay());  
}

export default {
  getWeek,
}


// WEBPACK FOOTER //
// ./src/filter/util.js